<template>
  <v-container class="mb-10 ">
    <v-row class="px-5">
      <v-col cols="12" class="contact__section d-flex flex-column align-items-center justify-center">
        <h2 class="font-weight-bold text-center mb-6" >سوالی داری که بهش جواب ندادیم؟</h2>
        <span class="mb-6 text-center">با این شماره تماس بگیر تا پشتیبان‌های ما سریع جواب سوالات رو بدن.</span>
        <a href="tel:02191008020" >
          <span>۰۲۱۹۱۰۰۸۰۲۰</span>
          <img src="@/assets/images/talent_students/call.png" alt="call-icon-contact">
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Contact"
}
</script>

<style scoped lang="scss">
.contact__section{
  border: #EAECF0 solid 1px;
  border-radius: 32px;
  min-height: 250px;
  background: #F9FAFB;
  h2{
    font-size: 23px;
    @include media-breakpoint-down(md){
      font-size: 18px;
    }
  }
  p{
    font-size: 1.2rem;
    font-weight: 700;
    color: #101828;
  }
  a{

    span{
      font-size: 2rem;
      font-weight: 800;
      color: #101828;
      margin-left: 0.2rem;
    }
    img{
      width: 45px;
    }
  }


}
</style>
